import React from 'react'
import { shallow } from 'enzyme'

import { DeleteTopicConfirmationModal } from '../../modals/DeleteTopicConfirmationModal'
import Button from '../../../common/Button'

describe('DeleteTopicConfirmationModal', () => {
  let wrapper, props, instance
  beforeEach(() => {
    props = {
      highlightId: 123,
      toggleModal: jest.fn(),
      updateTopicList: jest.fn(),
      onCloseClick: jest.fn(),
      destroyHighlight: jest.fn(),
    },
    wrapper = shallow(<DeleteTopicConfirmationModal {...props} />)
    instance = wrapper.instance()
  })
  describe('#onDeleteClick', () => {
    it('should call props destroyHighlight method when highlightId exist', () => {
      instance.onDeleteClick()
      expect(props.destroyHighlight).toHaveBeenCalledTimes(1)
    })
    it('should call props onCloseClick method when highlightId is null', () => {
      props.highlightId = null
      wrapper = shallow(<DeleteTopicConfirmationModal {...props} />)
      instance = wrapper.instance()
      instance.onDeleteClick()
      expect(props.onCloseClick).toHaveBeenCalledTimes(1)
      expect(props.toggleModal).toHaveBeenCalledTimes(1)
    })
  })
  describe('#render', () => {
    describe('when Cancel button is clicked', () => {
      it('should call props toggleModal method', () => {
        const cancelBtn = wrapper.find('Button').at(0)
        cancelBtn.simulate('click')
        expect(props.toggleModal).toHaveBeenCalledTimes(1)
      })
    })
    describe('when Delete button is clicked', () => {
      xit('should call onDeleteClick method', () => {
        const onDeleteClick = spyOn(instance, 'onDeleteClick')
        const deleteBtn = wrapper.find('DeleteTopicConfirmationModal__Delete').at(0)
        deleteBtn.simulate('click')
        expect(onDeleteClick).toHaveBeenCalledTimes(1)
      })
    })
  })

})